import { Redirect, Route, Switch } from 'react-router-dom';

import { AppRoute } from ':cloud/utils/routes';
import { AdminCluster } from ':cloud/widgets/admin/Clusters';
import { AdminOrg } from ':cloud/widgets/admin/Organizations';
import { AdminProtocols } from ':cloud/widgets/admin/Protocols';

export function AdminDashboard() {
  return (
    <Switch>
      <Route exact path={AppRoute.Admin.Protocols}>
        <AdminProtocols />
      </Route>
      <Route exact path={AppRoute.Admin.Clusters}>
        <AdminCluster />
      </Route>
      <Route exact path={AppRoute.Admin.Organizations}>
        <AdminOrg />
      </Route>
      <Redirect to={AppRoute.Admin.Organizations} />
    </Switch>
  );
}
